module.exports = "<div class=\"layout-sidebar\">\n    <header-private class=\"topbar-wrapper\"></header-private>\n    <sidebar class=\"sidebar-wrapper\"></sidebar>\n    <ui-view class=\"body-wrapper\"></ui-view>\n    <footer class=\"footer-wrapper\"></footer>\n    <sidebar-ai></sidebar-ai>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/regular/template.html
// module id = 1625
// module chunks = 0